import i18next from "src/i18n/config";

import { Theme } from "@mui/material";

export const getStatusIndicatorData = (status: string, theme: Theme) => {
    const normalizedStatus = status.trim().toLowerCase();

    switch (normalizedStatus) {
        case "active":
            return {
                tooltip: i18next.t("common:status.active"),
                color: theme.palette.emteria.success,
            };
        case "cancelled":
            return {
                tooltip: i18next.t("common:status.cancelled"),
                color: theme.palette.emteria.warning,
            };
        case "expired":
            return {
                tooltip: i18next.t("common:status.expired"),
                color: theme.palette.emteria.error,
            };
        case "terminated":
            return {
                tooltip: i18next.t("common:status.terminated"),
                color: theme.palette.emteria.background.disabled,
            };
        default:
            return {
                tooltip: i18next.t("pages:clientsOverviewPage.table.tooltip.unknownStatus"),
                color: theme.palette.emteria.text.secondary,
            };
    }
};
